import { StateCreator } from "zustand";
import { FindByUuid } from "../../../domain/models/find-by-uuid";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteFindByUuid } from "../../../data/usecases/remote-find-by-uuid";
import { FetchState } from "../../../domain/models/fetch-state";
import Swal from "sweetalert2";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FindCustomerByUuidInterface {
  findCustomer: Function;
  customerDataByUuid: FindByUuid;
  customerDatafetchState: FetchState;
}

const initialStaes = {
  customerDataByUuid: {} as FindByUuid,
  customerDatafetchState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFindCustomerByUuidSlice: StateCreator<
  FindCustomerByUuidInterface
> = (set, get) => ({
  ...initialStaes,
  findCustomer: async (id: string) => {
    set(() => ({ customerDatafetchState: FetchState.LOADING }));
 const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
 const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteFindCustomerByUuid = new RemoteFindByUuid(
      `${BASE_URL}${Endpoints.FIND_BY_UUID}`,
      axiosHttpClient
    );

    let payload = {
      uuid: id,
      identification: true,
    };

    let result = await remoteFindCustomerByUuid.fetch(payload);

    if (result) {
      set(() => ({ customerDatafetchState: FetchState.SUCCESS }));
      set(() => ({ customerDataByUuid: result }));
    } else {
      set(() => ({ customerDatafetchState: FetchState.DEFAULT }));

      Swal.fire({
        timer: 3000,
        icon: "error",
        text: "Not Found",
        customClass: {
          container: "swal2-style",
        },
      });
    }
  },
});
